import { render, staticRenderFns } from "./uOttawa1321Lab6ReagentTable.vue?vue&type=template&id=604f425a&scoped=true&"
import script from "./uOttawa1321Lab6ReagentTable.vue?vue&type=script&lang=ts&"
export * from "./uOttawa1321Lab6ReagentTable.vue?vue&type=script&lang=ts&"
import style0 from "./uOttawa1321Lab6ReagentTable.vue?vue&type=style&index=0&id=604f425a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604f425a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VBtnToggle,VContainer,VRow,VSimpleTable})
